var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path6, _rect3, _rect4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 516.07 597.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 219.16,
    x2: 593.72,
    y1: 552.93,
    y2: 552.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 278.51,
    x2: 755.96,
    y1: 363.85,
    y2: 336.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#58a0ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4c718a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#485f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#475c74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#41455e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 406.51,
    x2: 420.76,
    y1: 686.89,
    y2: 14.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 410.36,
    x2: 483.27,
    y1: 191.67,
    y2: 191.67,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 414.47,
    x2: 419.92,
    y1: 450.62,
    y2: 743.9,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 358.42,
    x2: 426.24,
    y1: 70.09,
    y2: 70.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 403.48,
    x2: 491.46,
    y1: 92.16,
    y2: 113.9,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 415.39,
    x2: 448.54,
    y1: 38.04,
    y2: 38.04,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 651.76,
    x2: 674.92,
    y1: -13.48,
    y2: 9.56,
    gradientTransform: "rotate(-6.47 922.55 1878.507)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 373.54,
    x2: 388.17,
    y1: 234.55,
    y2: 234.55,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 372.89,
    x2: 386.11,
    y1: 235.15,
    y2: 247.44,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 414.79,
    x2: 427.96,
    y1: 234.88,
    y2: 234.88,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 414.89,
    x2: 426.38,
    y1: 236.63,
    y2: 246.26,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 438.37,
    x2: 473.22,
    y1: 64.79,
    y2: 64.79,
    xlinkHref: "#c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M67.87 471.39c-6.68-32.72 7-68.21-4.87-99.42-9.79-25.68-34.68-42.32-49.29-65.6-18.72-29.82-18.22-70.58 1.22-99.93 20.56-31 57.26-46.53 86.14-70 18.83-15.32 34.54-34.28 54-48.77s44.68-24.33 68-17.6c14.95 4.32 27.29 14.87 41.64 20.88 32.39 13.58 69.1 2.45 104.13-.27a213.36 213.36 0 0 1 90.09 12.51c18.23 6.72 36.27 16.62 46.89 32.89 11.17 17.12 12.52 39.33 7.36 59.11s-16.21 37.51-28.44 53.89c-19 25.38-42.6 55.05-32.37 85 6.48 19 24.88 31 37.12 46.88 26.5 34.46 18.61 90.14-16.39 115.87-14.21 10.44-32 16.51-43.08 30.23-6.13 7.59-9.71 17-16 24.49-16.24 19.49-45.12 21-70.48 20.8q-46.17-.36-92.32-1.44c-27.09-.63-64.49 4.74-90.34-3.39-38.27-12.06-84.9-56.44-93.01-96.13Z",
    opacity: 0.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M250.79 541.78c-15 4.38-32.81 13.8-31.57 29.38 1.27 15.94 21.11 22.2 37 23.68 30.26 2.8 60.72 2.55 91.11 2.29l127.13-1.07c29.35-.25 58.9-.52 87.69-6.2 9.12-1.8 18.61-4.4 25.2-11s8.94-18.23 2.68-25.11c-5.83-6.4-15.94-6.11-23.58-10.19-8.54-4.56-13.1-14-20-20.79C531.3 508 507.5 508 486.33 508.91L347.7 515c-17.22.75-41-2.6-57.19 4-13.8 5.52-22.51 22.78-39.72 22.78Z",
    opacity: 0.19,
    transform: "translate(-134.9)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248.42,
    height: 430.99,
    x: 145.39,
    y: 148.86,
    fill: "url(#d)",
    rx: 23.66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 248.42,
    height: 430.99,
    x: 154.67,
    y: 148.86,
    fill: "#68e1fd",
    rx: 23.66
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M526.1 182.76V504a20.64 20.64 0 0 1-20.64 20.64H322.1A20.65 20.65 0 0 1 301.46 504V182.76a20.65 20.65 0 0 1 20.64-20.64h49.25V169a10.87 10.87 0 0 0 10.87 10.87h73.17A10.87 10.87 0 0 0 466.26 169v-6.84h39.2a20.64 20.64 0 0 1 20.64 20.6Z",
    transform: "translate(-134.9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M456 167.55c-3.05 2.88-7.55 4.58-9.06 8.5-1.25 3.24.05 6.84.5 10.28 1 7.73-2.27 15.26-4.44 22.75a80.87 80.87 0 0 0-3.19 22.78c0 3.78.23 7.83-1.76 11s-7.28 4.58-9.48 1.51a7.4 7.4 0 0 1-1-2.22c-3.57-11.45-1.42-23.82-1.57-35.85s-3.9-25.55-14.58-31.08a482.06 482.06 0 0 1-11.1 62.07c-1.08 4.4-3.44 9.75-8 9.65-.84-6.48-1.17-13-1.5-19.54l-3.74-74.39c-.1-2-.18-4.22.75-6 1.39-2.76 4.62-4 7.59-4.86a138.82 138.82 0 0 1 34.7-5.67c7.87-.28 19.47 1.26 25.12 7.62 5.27 5.9 6.85 17.69.76 23.45Z",
    opacity: 0.19,
    transform: "translate(-134.9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M436.57 563.75h-40.44a12.36 12.36 0 0 1-12.36-12.36A12.35 12.35 0 0 1 396.13 539h40.44a12.35 12.35 0 0 1 12.35 12.35 12.35 12.35 0 0 1-12.35 12.4Z",
    transform: "translate(-134.9)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360.38,
    cy: 313.36,
    r: 23.39,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.82,
    transform: "rotate(-76.72 292.915 398.588)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.51,
    cy: 313.36,
    r: 23.39,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.82,
    transform: "rotate(-76.72 353.045 398.585)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.64,
    cy: 313.36,
    r: 23.39,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.82,
    transform: "rotate(-76.72 413.17 398.589)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.38,
    cy: 375.33,
    r: 23.39,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.82,
    transform: "rotate(-76.72 292.913 460.554)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.51,
    cy: 375.33,
    r: 23.39,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.82,
    transform: "rotate(-76.72 353.038 460.557)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.09,
    cy: 462.81,
    r: 31.63,
    fill: "#ff354e",
    transform: "rotate(-45 355.638 625.64)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.64,
    cy: 375.33,
    r: 23.39,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.82,
    transform: "rotate(-76.72 413.168 460.555)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M268.74 461.24a1.34 1.34 0 0 1-1.22-1.85c1.08-2.74 4-11.3 20.35-11.3 15.44 0 18.92 8.54 20.06 11.28a1.34 1.34 0 0 1-1.21 1.87h-6.18a1.31 1.31 0 0 1-1.15-.68c-.81-1.5-2.65-8.71-11.81-8.71-7.46 0-10.23 4-11.77 8.48a1.34 1.34 0 0 1-1.25.91Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.34,
    height: 8.95,
    x: 263.54,
    y: 460.01,
    fill: "#fff",
    rx: 3.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 15.34,
    height: 8.95,
    x: 295.8,
    y: 460.01,
    fill: "#fff",
    rx: 3.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M395.71 81.67c-1.59-2.62-7.65-16.9-9.87-22L378 41.78a6.07 6.07 0 0 0 0 5.28 119.22 119.22 0 0 0-15.54 1.77c-1.77.32-3.93 1.1-4.08 2.89-.11 1.22.82 2.26 1.74 3.07A25.64 25.64 0 0 0 371 60.38c2.23.53 4.79.91 6.11 2.78a8.22 8.22 0 0 1 1.12 3.62 217.69 217.69 0 0 0 5.05 24.37c.76 2.86 1.95 6.1 4.76 7 1.8.59 3.75 0 5.54-.6 5.44-1.83 10.89-4 15.33-7.63 5.33-4.38 24-28 14.76-33.56-4.52-2.73-16.76 11.84-19.16 14.81-3.65 4.56-4.36 6.65-8.8 10.5Z",
    transform: "translate(-134.9)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M368.4 112.35a15.36 15.36 0 0 1-6.22 1.86c-1.4.19-2.83.31-4.25.37-8.53.35-17.26-1.61-23.84-6.94-3.5-2.84-6.33-6.55-10.23-8.82a25.75 25.75 0 0 0-9.64-2.89c-2.74-.37-5.54-.54-8.27-.87-6.1-.73-12.8-2.85-15.63-8.31-2-3.76-1.61-8.27-1-12.47 1.16-8 3.07-16 3.41-24.15.19-4.4-.14-9-2.5-12.73-1.58-2.48-3.94-4.34-5.79-6.62-5.18-6.4-1.6-16.54 5.21-20.35a20.64 20.64 0 0 0 3.67-2.15c1.39-1.22 2.15-3 3.37-4.4C300.1-.06 306.1-.15 311.25.07l8.85.38c2.86.12 6.16.49 7.68 2.91 1.17 1.86.95 4.56 2.67 5.93a7.1 7.1 0 0 0 2 1A22.58 22.58 0 0 1 346.1 24.7c2.55 8.46-.07 17.83 2.47 26.28a5 5 0 0 0 1.09 2.13 7.88 7.88 0 0 0 2.52 1.32c5.56 2.45 7.28 9.57 6.83 15.62-.25 3.41-.94 7 .32 10.14.91 2.28 2.73 4.06 4.46 5.8 3.65 3.65 7.25 7.64 8.75 12.58s.25 11.07-4.14 13.78Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M357.93 114.58c-8.53.35-17.26-1.61-23.84-6.94-3.5-2.84-6.33-6.55-10.23-8.82a25.75 25.75 0 0 0-9.64-2.89c-3.59-4-7.14-8.07-10.58-12.21-2.66-3.2-5.28-6.51-6.87-10.36s-2-7.76-2.51-11.76c-1.35-11.15-2.66-22.71.83-33.38a15.43 15.43 0 0 1 2-4.32c6-8.3 21.92-7 27.15 1.34a24.45 24.45 0 0 1 2.75 7.67 89.67 89.67 0 0 1 1.88 13.23c.24 3.71.38 7.76 2.81 10.57 1.52 1.75 3.75 2.76 5.39 4.41 6.28 6.29 1.31 18 6.38 25.32a19.92 19.92 0 0 0 4.65 4.35c4.05 3 8.4 5.94 10.92 10.31s2.55 10.3-1.09 13.48Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M275.82 120.12s-37.09 6.79-38.16 16.72 6.72 92.16 6.72 92.16h8.49s15.25-45 12.62-58.23-5.3-16.91-5.3-16.91 15.45 7.63 30.06-9.2 8.09-28.08 8.09-28.08Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M296.68 118.1s-35.37 13.06-34.73 23 22.41 89.62 22.41 89.62l8.37-1.46s7.31-46.92 2.45-59.54S287.1 154 287.1 154s20.46 9.4 32.48-9.37c10.18-15.92-6.68-32.06-17.06-28.51Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M275.82 120.12V99.23s-6.14-11.4-7.14-17.27c-.58-3.4 3.71-13.83 8.65-17.86 3.44-2.8 6-7.79 10.4-7.93l21.59-.65 10.58 30-3.73 34.78s-9.07-4.7-40.35-.18Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M432.93 115.34c-.25.41-1.47 2.3-1.35 2.76s5.75.61 7.77.81c3.44.34 8.28 1 11.72 1.38 2.33-11.43 1.17-18.66 2.87-24.83a5.64 5.64 0 0 0 .47-2.3c-.2-1.38-5.13-8.47-6.36-9-4-1.73-4 4.32-4.46 6.56-1.68 8.85-5.99 17.02-10.66 24.62Z",
    transform: "translate(-134.9)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M418.18 20.79s-5 16.67-1.58 19.53 6.4 3.26 7.1 4.68 2.46 7.45 0 11.41-1.29 9.59 2.3 7.69 11.57-7.73 11.57-7.73l4.6-16.73s7.36-17.54 6.22-21.38-19.07-14.13-30.21 2.53Z",
    transform: "translate(-134.9)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M304.94 25.14c.54 2.1-.42 4.38.17 6.47.73 2.58 3.53 4 6.14 4.59s5.44.8 7.67 2.31c2.52 1.7 4.06 5 7 5.65a9.26 9.26 0 0 0 4.38-.42c3.24-.84 6.73-1.84 8.77-4.5a9.82 9.82 0 0 0 1.83-5c.72-7.06-4.12-13.72-10.15-17.47s-13.15-5.21-20-7c-3.8-1-12.8-3.82-14.9 1.3-1.49 3.63 1.91 10.23 6.16 6.8-.41 2.82 2.28 4.71 2.93 7.27Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M448.58 40.66s-4.43 3.58-7.12 2.6-7.3 5-7.3 5-1.42 2.42 1.72 3.6a13.93 13.93 0 0 0 10.79-.61C452.41 48.34 459 40 461.46 37.54c5.41-5.51 4.2-18-1.93-18.73s-5.12 6.23-4.9 6.55a6.21 6.21 0 0 0 1.34.72 2.73 2.73 0 0 1 1.2 3.93c-2.26 3.62-6.3 9.7-8.59 10.65Z",
    transform: "translate(-134.9)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M373.77 238.5a1.88 1.88 0 0 0-.21 1 1.26 1.26 0 0 0 1 .91 3.58 3.58 0 0 0 1.42-.07 18.57 18.57 0 0 0 8.44-3.58 9.61 9.61 0 0 0 3.71-8.09c0-.25-8.37 0-9.29.66-2.37 1.67-3.99 6.57-5.07 9.17Z",
    transform: "translate(-134.9)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m370.16 244.05 3.61-5.55s8.3 4.09 13.1-4.57c2.46-4.45 1.26-5.23 1.26-5.23s2.91.65 3.38 5.91a53.42 53.42 0 0 1 0 9.44l-2.17 1.2-1.17-4.76s-5.54 7.54-7.23 10.06c-.88 1.31-5 2.3-8.71 2.95a3.87 3.87 0 0 1-4.13-5.5c.55-1.14 1.23-2.44 2.06-3.95Z",
    transform: "translate(-134.9)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M415 239a1.7 1.7 0 0 0-.13 1 1.19 1.19 0 0 0 1 .79 3.18 3.18 0 0 0 1.33-.15 17.43 17.43 0 0 0 7.72-3.87 9.07 9.07 0 0 0 3-7.82c-.05-.22-7.87.5-8.7 1.17-2.22 1.75-3.41 6.4-4.22 8.88Z",
    transform: "translate(-134.9)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M411.89 244.46 415 239s8 3.36 12-5.06c2.05-4.33.88-5 .88-5s2.77.45 3.52 5.36a50.15 50.15 0 0 1 .55 8.87l-2 1.26-1.38-4.41s-4.76 7.42-6.21 9.88c-.75 1.28-4.54 2.46-8 3.29a3.64 3.64 0 0 1-4.21-5c.48-1 1.05-2.26 1.74-3.73Z",
    transform: "translate(-134.9)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M438.5 67.17s15.93 47.45 34.15 29.64c3.53-3.45-10.49-53.83-11.23-55s1-9-.74-10.45a18.65 18.65 0 0 0-4.34-2.57s-2.46.4-2.37 2.07-2.36 3.16-2.86 4.34-3.11 4.8-2.69 6.3a23 23 0 0 0 2.31 4.84c.38.39 6.86 30.14 6.86 30.14s-6.15-22.83-13.37-21-5.72 11.69-5.72 11.69Z",
    transform: "translate(-134.9)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.3527e4205ba2219950189a57c587b8c6.svg";
export { ForwardRef as ReactComponent };